import { graphql } from 'gql';

export const catalogImportUerBaseCostWorkTypesGql = graphql(`
    mutation catalogImportUerBaseCostWorkTypes($file: FileInput!, $catalogId: Long!) {
        catalogImportUerBaseCostWorkTypes(file: $file, catalogId: $catalogId) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            actionRequired
            validation {
                property
                message
                metadata
                source
            }
        }
    }
`);

export const catalogUERBaseCostItemsGql = graphql(`
    query catalogUERBaseCostItems(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $ratioGroupIds: [Long!]
        $where: CatalogUERBaseCostDataFilterInput
        $order: [CatalogUERBaseCostDataSortInput!]
    ) {
        catalogUERBaseCostItems(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            ratioGroupIds: $ratioGroupIds
            where: $where
            order: $order
        ) {
            items {
                catalogUERBaseCostWorkScopes {
                    id
                    name
                    number
                }
                chapter
                code
                constructionTypes {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                version
                emm
                eqp
                groupId
                groupName
                id
                mtr
                name
                nr
                ozp
                pir
                sectionId
                sectionName
                sp
                trn
                uerClassifier
                uniqueId
                unit
                unitCost
                updatedAt
                workType {
                    workCode
                    workInSum
                    workName
                    workRatio
                    workUniqueId
                    workUnit
                }
                zpm
                justification
            }
            totalCount
        }
    }
`);

export const catalogUERBaseCostUpdateDateFilter = graphql(`
    query catalogUERBaseCostUpdateDateFilter(
        $where: FilterValueOfNullableOfDateTimeFilterInput
        $catalogUniqueId: String!
    ) {
        catalogUERBaseCostUpdateDateFilter(where: $where, take: 1000, catalogUniqueId: $catalogUniqueId) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostSectionNameFilter = graphql(`
    query catalogUERBaseCostSectionNameFilter(
        $where: FilterValueOfStringFilterInput
        $catalogUniqueId: String!
        $order: [FilterValueOfStringSortInput!]
        $ratioGroupIds: [Long!]
        $input: CatalogUERBaseCostFilterInput!
    ) {
        catalogUERBaseCostSectionNameFilter(
            where: $where
            catalogUniqueId: $catalogUniqueId
            take: 1000
            order: $order
            ratioGroupIds: $ratioGroupIds
            input: $input
        ) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostGroupNameFilter = graphql(`
    query catalogUERBaseCostGroupNameFilter(
        $where: FilterValueOfStringFilterInput
        $catalogUniqueId: String!
        $order: [FilterValueOfStringSortInput!]
        $ratioGroupIds: [Long!]
        $input: CatalogUERBaseCostFilterInput!
    ) {
        catalogUERBaseCostGroupNameFilter(
            where: $where
            take: 1000
            catalogUniqueId: $catalogUniqueId
            order: $order
            ratioGroupIds: $ratioGroupIds
            input: $input
        ) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostCodeFilter = graphql(`
    query catalogUERBaseCostCodeFilter(
        $where: FilterValueOfStringFilterInput
        $catalogUniqueId: String!
        $order: [FilterValueOfStringSortInput!]
        $input: CatalogUERBaseCostFilterInput!
    ) {
        catalogUERBaseCostCodeFilter(
            where: $where
            take: 1000
            catalogUniqueId: $catalogUniqueId
            order: $order
            input: $input
        ) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostNameFilter = graphql(`
    query catalogUERBaseCostNameFilter(
        $where: FilterValueOfStringFilterInput
        $catalogUniqueId: String!
        $order: [FilterValueOfStringSortInput!]
        $ratioGroupIds: [Long!]
        $input: CatalogUERBaseCostFilterInput!
    ) {
        catalogUERBaseCostNameFilter(
            where: $where
            take: 1000
            catalogUniqueId: $catalogUniqueId
            order: $order
            ratioGroupIds: $ratioGroupIds
            input: $input
        ) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostChapterFilter = graphql(`
    query catalogUERBaseCostChapterFilter(
        $where: FilterValueOfNullableOfChapterEnumFilterInput
        $catalogUniqueId: String!
        $order: [FilterValueOfNullableOfChapterEnumSortInput!]
        $ratioGroupIds: [Long!]
        $input: CatalogUERBaseCostFilterInput!
    ) {
        catalogUERBaseCostChapterFilter(
            where: $where
            take: 1000
            catalogUniqueId: $catalogUniqueId
            order: $order
            ratioGroupIds: $ratioGroupIds
            input: $input
        ) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostUerClassifierFilter = graphql(`
    query catalogUERBaseCostUerClassifierFilter(
        $where: FilterValueOfNullableOfUerClassifierEnumFilterInput
        $catalogUniqueId: String!
        $order: [FilterValueOfNullableOfUerClassifierEnumSortInput!]
        $ratioGroupIds: [Long!]
        $input: CatalogUERBaseCostFilterInput!
    ) {
        catalogUERBaseCostUerClassifierFilter(
            where: $where
            take: 1000
            catalogUniqueId: $catalogUniqueId
            order: $order
            ratioGroupIds: $ratioGroupIds
            input: $input
        ) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostWorktypeNameFilter = graphql(`
    query catalogUERBaseCostWorktypeNameFilter(
        $where: FilterValueOfStringFilterInput
        $catalogUniqueId: String!
        $order: [FilterValueOfStringSortInput!]
        $input: CatalogUERBaseCostFilterInput!
    ) {
        catalogUERBaseCostWorktypeNameFilter(
            where: $where
            take: 1000
            catalogUniqueId: $catalogUniqueId
            order: $order
            input: $input
        ) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostWorktypeFOsummFilter = graphql(`
    query catalogUERBaseCostWorktypeFOsummFilter(
        $where: FilterValueOfWorkInSumEnumFilterInput
        $catalogUniqueId: String!
        $order: [FilterValueOfWorkInSumEnumSortInput!]
        $ratioGroupIds: [Long!]
        $input: CatalogUERBaseCostFilterInput!
    ) {
        catalogUERBaseCostWorktypeFOsummFilter(
            where: $where
            take: 1000
            catalogUniqueId: $catalogUniqueId
            order: $order
            ratioGroupIds: $ratioGroupIds
            input: $input
        ) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const catalogUpdateUerBaseCostGql = graphql(`
    mutation catalogUpdateUerBaseCost($costData: UpdateCatalogUERBaseCostInput!) {
        catalogUpdateUerBaseCost(costData: $costData) {
            data {
                catalogUERBaseCostWorkScopes {
                    id
                    name
                    number
                }
                chapter
                code
                constructionTypes {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                emm
                eqp
                groupId
                groupName
                id
                mtr
                name
                nr
                ozp
                pir
                sectionId
                sectionName
                sp
                trn
                uerClassifier
                uniqueId
                unit
                unitCost
                updatedAt
                workType {
                    workCode
                    workInSum
                    workName
                    workRatio
                    workUniqueId
                    workUnit
                }
                zpm
            }
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const catalogRemoveUerBaseCostGql = graphql(`
    mutation catalogRemoveUerBaseCost($uerBaseCostIds: [Long!]!) {
        catalogRemoveUerBaseCost(uerBaseCostIds: $uerBaseCostIds) {
            data
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const catalogUERBaseCostEstimateBasisRowsGql = graphql(`
    query catalogUERBaseCostEstimateBasisRows(
        $catalogUniqueId: String!
        $uerBaseCostId: Long!
        $where: CatalogUERBaseCostEstimateBasisRowFilterInput
    ) {
        catalogUERBaseCostEstimateBasisRows(
            catalogUniqueId: $catalogUniqueId
            uerBaseCostId: $uerBaseCostId
            where: $where
        ) {
            code
            estimateTotal
            isDeleted
            isNotCount
            isPriceHeadLine
            isSectionHeadLine
            name
            number
            parentRowId
            priceId
            quantity {
                total
                unit
            }
            resourceId
            rowId
            sectionId
            totalCost {
                emm
                mtr
                ozp
                total
                zpm
                nr
                sp
            }
            totalWorkCost {
                tm
                tz
            }
            unit
            unitCost {
                emm
                mtr
                ozp
                total
                zpm
            }
            unitWorkCost {
                tm
                tz
            }
        }
    }
`);

export const catalogUERBaseCostTotalsGql = graphql(`
    query catalogUERBaseCostTotals($catalogUniqueId: String!, $uerBaseCostId: Long!) {
        catalogUERBaseCostTotals(catalogUniqueId: $catalogUniqueId, uerBaseCostId: $uerBaseCostId) {
            hasIndent
            isHeadLine
            name
            sortOrder
            value
        }
    }
`);

export const catalogUERBaseCostWorkScopesGql = graphql(`
    query catalogUERBaseCostWorkScopes(
        $catalogUniqueId: String!
        $skip: Int
        $take: Int
        $uerBaseCostId: Long!
        $where: CatalogUERBaseCostWorkScopeBaseDataFilterInput
    ) {
        catalogUERBaseCostWorkScopes(
            catalogUniqueId: $catalogUniqueId
            skip: $skip
            take: $take
            uerBaseCostId: $uerBaseCostId
            where: $where
        ) {
            items {
                name
                number
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogUERBaseCostEstimateBasisResourcesGql = graphql(`
    query catalogUERBaseCostEstimateBasisResources(
        $catalogUniqueId: String!
        $skip: Int
        $take: Int
        $uerBaseCostId: Long!
        $where: CatalogUERBaseCostEstimateBasisItemFilterInput
    ) {
        catalogUERBaseCostEstimateBasisResources(
            catalogUniqueId: $catalogUniqueId
            skip: $skip
            take: $take
            uerBaseCostId: $uerBaseCostId
            where: $where
        ) {
            items {
                code
                group
                id
                isDeleted
                isHeadLine
                isNotCount
                name
                unit
                unitCost
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogUERBaseCostEstimateBasisGql = graphql(`
    query catalogUERBaseCostEstimateBasis(
        $catalogUniqueId: String!
        $skip: Int
        $take: Int
        $uerBaseCostId: Long!
        $where: CatalogUERBaseCostEstimateBasisItemFilterInput
    ) {
        catalogUERBaseCostEstimateBasis(
            catalogUniqueId: $catalogUniqueId
            skip: $skip
            take: $take
            uerBaseCostId: $uerBaseCostId
            where: $where
        ) {
            items {
                code
                group
                id
                isDeleted
                isHeadLine
                isNotCount
                name
                unit
                unitCost
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogUERBaseCostHistoryItemsGql = graphql(`
    query catalogUERBaseCostHistoryItems(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $where: CatalogUERBaseCostHistoryDataFilterInput
    ) {
        catalogUERBaseCostHistoryItems(skip: $skip, take: $take, catalogUniqueId: $catalogUniqueId, where: $where) {
            totalCount
            items {
                id
                isHeadLine
                catalogId
                uerBaseCostId
                uerBaseCostCode
                uerBaseCostChangeType
                updateUerDate
                catalogUERBaseCostChange {
                    groupCode
                    groupCodeCng
                    groupFullName
                    groupFullNameCng
                    code
                    codeCng
                    unit
                    unitCng
                    name
                    nameCng
                    ozp
                    ozpCng
                    emm
                    emmCng
                    zpm
                    zpmCng
                    mtr
                    mtrCng
                    fot
                    fotCng
                    eqp
                    eqpCng
                    pir
                    pirCng
                    trn
                    trnCng
                    nr
                    nrCng
                    sp
                    spCng
                    tz
                    tzCng
                    tm
                    tmCng
                    chapter
                    chapterCng
                    uerClassifier
                    uerClassifierCng
                    hasWorkScopesHistory
                    constructionTypeCng
                    constructionTypes {
                        id
                        name
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    justification
                    justificationCng
                    unitCost
                    unitCostCng
                }
            }
        }
    }
`);

export const updateCatalogUERBaseCostWorkScopesGql = graphql(`
    mutation updateCatalogUERBaseCostWorkScopes(
        $uerBaseCostId: Long!
        $inputs: [CatalogUERBaseCostWorkScopeUpdateInput!]!
    ) {
        updateCatalogUERBaseCostWorkScopes(uerBaseCostId: $uerBaseCostId, inputs: $inputs) {
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const catalogUERBaseCostHistoryStatusCountsGql = graphql(`
    query catalogUERBaseCostHistoryStatusCounts($catalogUniqueId: String!, $startDate: DateTime!, $endDate: DateTime!) {
        catalogUERBaseCostHistoryStatusCounts(
            catalogUniqueId: $catalogUniqueId
            startDate: $startDate
            endDate: $endDate
        ) {
            result
            data {
                newCostsCount
                deletedCostsCount
                updatedCostsCount
            }
        }
    }
`);

export const exportCatalogUERBaseCostHistoryAsExcelGql = graphql(`
    query exportCatalogUERBaseCostHistoryAsExcel(
        $catalogUniqueId: String!
        $startDate: DateTime!
        $endDate: DateTime!
    ) {
        exportCatalogUERBaseCostHistoryAsExcel(
            catalogUniqueId: $catalogUniqueId
            startDate: $startDate
            endDate: $endDate
        ) {
            data {
                name
                count
                size
                dataUrl
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const catalogUpsertMultiUerBaseCostBasisesGql = graphql(`
    mutation catalogUpsertMultiUerBaseCostBasises($input: CatalogUpsertMultiUerBaseCostBasisesInput!) {
        catalogUpsertMultiUerBaseCostBasises(input: $input) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            actionRequired
            validation {
                property
                message
                metadata
            }
            data {
                version
                uerNacl
                uerPlan
                catFile
                workID
            }
        }
    }
`);

export const catalogUpsertArchiveUerBaseCostBasisesGql = graphql(`
    mutation catalogUpsertArchiveUerBaseCostBasises($input: CatalogUpsertArchiveUerBaseCostBasisesInput!) {
        catalogUpsertArchiveUerBaseCostBasises(input: $input) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            actionRequired
            validation {
                property
                message
                metadata
                source
            }
            data {
                version
                uerNacl
                uerPlan
                catFile
                workID
            }
        }
    }
`);

export const exportCatalogUerBaseCostGql = graphql(`
    query exportCatalogUERAsExcel($catalogUniqueId: String!) {
        exportCatalogUERAsExcel(catalogUniqueId: $catalogUniqueId) {
            result
            message
            buttonText
            actionRequired
            code
            hasValidation
            hideValidation
            validation {
                property
                message
            }
            data {
                count
                dataUrl
                name
                size
            }
        }
    }
`);

export const setCatalogUERBaseCostPropertiesGql = graphql(`
    mutation setCatalogUERBaseCostProperties($catalogId: Long!, $input: CatalogUERBaseCostPropertiesInput!) {
        setCatalogUERBaseCostProperties(catalogId: $catalogId, input: $input) {
            result
            message
            buttonText
            actionRequired
            code
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
